import api from './api'

const url = 'vacation'

const findVacation = () => api.get(url)

export { findVacation }
